// extracted by mini-css-extract-plugin
export default {"container":"GaVvX4cj","image":"wCQmoGlU","content":"TFg61wKM"};